import React from 'react';
import { API } from 'aws-amplify';
import { toast } from 'react-toastify';
import { t } from 'i18next';

import reducer from './reducer';

const useApplication = (appInstId) => {
    const [application, dispatch] = React.useReducer(reducer, { AppInstID: appInstId });

    const [doingAjax, setDoingAjax] = React.useState(true);
    const [isInitialized, setIsInitialized] = React.useState(false);

    const [selectedAction, setSelectedAction] = React.useState();
    const [forceReload, setForceReload] = React.useState(false);
    // const [actions, setActions] = React.useState([])

    const retrieveApp = async () => {
        setDoingAjax(true);

        try {
            // let resp = await API.get()
            var _record = await API.get('ShipyardAPI', `/application/${application.AppInstID}`, {
                queryStringParameters: {
                    userType: 3,
                },
            });

            dispatch({ type: 'set', payload: _record });

            setIsInitialized(true);
        } catch (e) {
            toast.error(t('General.AjaxError'));
            console.log(JSON.stringify(e));
        } finally {
            setDoingAjax(false);
        }
    };

    const updateAnswer = async (newAns, questionInst) => {
        console.log(`The newly received answer: ${newAns}`);

        console.log(`The previous answer was: ${questionInst?.answerText}`);

        try {
            var updateAnswerResponse = await API.put('ShipyardAPI', `/application/${application.AppInstID}/answer/${questionInst.id}`, {
                body: { responseText: newAns },
            });
        } catch (apiErr) {
            toast.error(t('General.AjaxError'));
        }

        if (!updateAnswerResponse.success) {
            //restore
        }

        try {
            var _record = await API.get('ShipyardAPI', `/application/${application.AppInstID}`, {
                queryStringParameters: {
                    userType: 3,
                },
            });

            dispatch({ type: 'set', payload: _record });
        } catch (e) {
            toast.error(t('General.AjaxError'));
        }
    };

    const handleStatusChange = async (shouldForceReload = false) => {
        setSelectedAction();
        if (shouldForceReload) {
            setForceReload(shouldForceReload);
            let loading = toast.loading('Finalizing status change.');

            try {
                await retrieveApp();
                toast.dismiss(loading);
                toast.success('Status change finalized!');
            } catch (e) {
                toast.dismiss(loading);
                toast.error('Error occured retrieving finalized data.');
            }
        }
    };

    return {
        isInitialized,
        doingAjax,
        application,
        forceReload,
        selectedAction,
        retrieveApp,
        updateAnswer,
        handleStatusChange,
        setSelectedAction,
    };
};

export default useApplication;
